const home = {
    defaultPortalName: 'Portal',
    heroSubtitle: 'Manage access for your automation platform',
    providerCardTitle: 'Provider Portal',
    providerCardDescription: 'Manage your API products and customers',
    providerCardCta: 'Sign in to access your provider dashboard',
    customerCardTitle: 'Customer Portal',
    customerCardDescription: 'Access your API subscriptions',
    customerCardCtaAuthenticated: 'Return to your subscriptions overview',
    customerCardCtaAnonymous: 'Preview the upcoming customer experience',
  } as const;

export default home;
